import Vue from "./../init";

export const ConfigResource = Vue.resource("config/{type}");
